import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from '../config/config.service';
import { httpExtensionService } from '../shared/services/httpextension.service';
import { SessionService } from '../shared/services/session.service';

@Injectable()
export class SettingsService {



    constructor(private http: httpExtensionService, private config: ConfigService, private sessionService: SessionService) {

    }


    private getToken() {
        let user_token;
        if (this.sessionService.checkSessionCookie() !== undefined) {
            user_token = this.sessionService.checkSessionCookie();
        } else if (this.sessionService.checkStorageSession() != null) {
            user_token = this.sessionService.checkStorageSession();
        }

        return user_token;
    }

    resetPassord(data: any): Observable<any> {
        const user_token: string = this.getToken();
        const headers = new Headers();


        let dadosJson = {
            id: data.id,
            currentPassword: data.currentpassword,
            newPassword: data.newpassword,
            rePassword: data.renewpassword,
            email:data.email
        }
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        let body = this.urlDataDecoded(dadosJson);

        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.apiURI + this.config.fundrasing_change_password, body, {
            headers: headers
        });
    }
    urlDataDecoded(data) {
        let searchParams = new URLSearchParams();
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                searchParams.set(key, data[key] + '');
            }
        }
        return searchParams.toString();
    }

    currentUser() {
        const user_token: string = this.getToken();
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.apiURI + this.config.fundrasing_currentuser, {
            headers: headers
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/settings/settings.service.ts